import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import LanguageIcon from "@mui/icons-material/Language";
import InsightsIcon from "@mui/icons-material/Insights";
import CampaignIcon from "@mui/icons-material/Campaign";
import BrushIcon from "@mui/icons-material/Brush";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const items = [
  { icon: LanguageIcon, title: "Desarrollo Web de Alto Rendimiento", desc: "Sitios modernos, rápidos, seguros y optimizados para SEO y UX." },
  { icon: InsightsIcon, title: "Analítica y Estrategia Digital", desc: "Decisiones guiadas por datos para maximizar retorno y crecimiento." },
  { icon: CampaignIcon, title: "Publicidad y Automatización", desc: "Google, Meta y TikTok con IA para segmentación y conversión." },
  { icon: BrushIcon, title: "Branding y Contenido", desc: "Identidad sólida y narrativa coherente en todos los canales." },
  { icon: AnalyticsIcon, title: "Posicionamiento en Google", desc: "SEO/SEM y Google Ads orientados a visibilidad real y autoridad." },
  { icon: AutoAwesomeIcon, title: "Innovación con IA", desc: "Integración de IA y automatización para escalar resultados." },
];

const cardVariants = {
  hidden: { opacity: 0, y: 18 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.45, delay: 0.08 * i, ease: "easeOut" } }),
};

export default function WhyChoose() {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#000",
        color: "#fff",
        py: { xs: 3, md: 5 },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(180deg, rgba(0,0,0,0.9) 0%, rgba(128,0,255,0.25) 100%)",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: 3, md: 6 },
        }}
      >
        <Typography
          component="h2"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: { xs: "1.6rem", sm: "2rem", md: "2.3rem" },
            mb: { xs: 4, md: 6 },
            color: "#8000FF",
          }}
        >
          ¿Por qué elegir DobleDx?
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 2.5, md: 3.5 },
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <Box
                key={it.title}
                component={motion.div}
                custom={i}
                variants={cardVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.25 }}
                sx={{
                  flex: "1 1 280px",
                  maxWidth: 300,
                  minWidth: 260,
                  background: "#1A0030",
                  border: "1px solid rgba(128,0,255,0.45)",
                  borderRadius: 4,
                  p: { xs: 3, md: 3.5 },
                  boxShadow: "0 0 24px rgba(128,0,255,0.35)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.25,
                  transition: "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 0 36px rgba(128,0,255,0.55)",
                    borderColor: "rgba(128,0,255,0.8)",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #3A0074, #8000FF)",
                      display: "grid",
                      placeItems: "center",
                      boxShadow: "0 0 16px #8000FF",
                      flexShrink: 0,
                    }}
                  >
                    <Icon sx={{ fontSize: 30, color: "#fff" }} />
                  </Box>
                  <Typography
                    component="h3"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: "1.05rem", sm: "1.15rem", md: "1.22rem" },
                      lineHeight: 1.2,
                    }}
                  >
                    {it.title}
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "#e6e6e6",
                    fontSize: { xs: ".98rem", md: "1.02rem" },
                    lineHeight: 1.6,
                    mt: 0.5,
                  }}
                >
                  {it.desc}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
